<template>
  <form @submit.prevent>
    <div>
      <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 " @activate-tab="clearFormIfLibraryViewActive">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <LibraryItems
            :hideAddFromLibrary="true"
            rightPanelId="sidebar-add-question-set"
            @interceptForSetParent="interceptForSetParent"
            organizationScopedState="organizationQuestionSet"
            libraryScopedState="questionSet"
            :query="query"
            :shouldAdaptSaveAsButtonTextToScopeAndCurrentAccount="true"
          />
        </b-tab>

        <b-tab v-if="Object.keys(copingEntity) && Object.keys(copingEntity).length > 0" :active="Object.keys(copingEntity) && Object.keys(copingEntity).length > 0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span>{{ $t("common.update") }}</span>
            </span>
          </template>
          <OrganizationQuestionSetDetail :hideGoBack="true" />
        </b-tab>
        <b-tab v-else>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("question-set.new") }}</span>
          </template>

          <OrganizationQuestionSetDetail :hideGoBack="true" />
        </b-tab>
      </b-tabs>

      <!-- <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("question-set.add-as") }}</span>
        </h2>

        <sweet-input
          inputClass="text-dark"
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('question-set.name')"
          :label="$t('question-set.name')"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

      </div> -->
      <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
        {{ $t("common.cancel") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationQuestionSetDetail from "../organization-question-set-detail.vue";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library", "product"],
  components: {
    LibraryItems,
    OrganizationQuestionSetDetail,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
      libraryItem: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    query() {
      const and = [];

      const products = [{ products: this.currentProduct || "PLATFORM" }];

      if (this.product && !products.some((i) => i.products === this.product)) {
        products.push({ products: this.product });
      }

      and.push({
        $or: products,
      });

      return { $and: and };
    },
    isUpdating() {
      return this.$store.getters["organizationQuestionSet/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationQuestionSet/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationQuestionSet/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationQuestionSet/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationQuestionSet/isCoping"];
    },
  },
  mounted() {},
  methods: {
    clearFormIfLibraryViewActive(e) {
      if (e == 0) {
        this.$store.dispatch("workspaceQuestionSet/resetForm");
        this.$store.dispatch("organizationQuestionSet/resetForm");
      }
    },
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationQuestionSet/addFromLibrary", {
          libraryItem: {
            ...this.libraryItem,
            name: {
              [this.currentLanguage]: this.form.name,
            },
          },
          product: this.product,
        });
        this.form = {};
        this.cancel();

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.dispatch("organizationQuestionSet/resetForm");
      this.$root.$emit("bv::toggle::collapse", "sidebar-add-question-set");
    },
    rightPanelClosed() {
      this.$store.dispatch("organizationQuestionSet/resetForm");
    },
    interceptForSetParent(item) {
      this.libraryItem = item;
      item.product = this.product;
      this.$store.commit(`workspaceQuestionSet/editedEntity`, { ...item });
    },
  },
};
</script>
